/*
 * ap-bestpreis.js — das "Bestpreis der letzten 30 Tage"-Signal der Buybox.
 *
 * Liest die eigene Preishistorie aus dem App-Proxy (/apps/tyre-search/
 * pricehistory — dieselbe Quelle wie das Preisverlauf-Widget) und zeigt den
 * Streifen NUR, wenn beides gilt:
 *
 *   1. current <= low30  — der aktuelle Preis ist das 30-Tage-Tief, und
 *   2. changes >= 1      — der Preis hat sich im Fenster ueberhaupt bewegt.
 *
 * Punkt 2 ist der Inflationsschutz: ein Preis, der 30 Tage flach stand, ist
 * formal auch "das Tief" — ein Badge darauf waere wertlos und stuende auf
 * jedem zweiten Produkt. Gezeigt wird eine TATSACHE ueber die EIGENE
 * Preishistorie ("unser guenstigster Preis der letzten 30 Tage"), keine
 * Marktbehauptung — deshalb rechtlich unkritisch (die Omnibus-Referenz
 * derselben Quelle traegt den PAngV-Streichpreis).
 *
 * Laedt bewusst VERZOEGERT (Idle bzw. 1,5 s): der Streifen ist Zugabe und
 * darf nicht mit LCP/CSS um die Verbindung konkurrieren. Ohne JS oder ohne
 * Antwort bleibt er einfach weg.
 */

(function () {
  'use strict';

  function boot() {
    var node = document.querySelector('[data-ap-bestpreis]');
    if (!node) return;
    var key = node.getAttribute('data-key');
    var proxy = node.getAttribute('data-proxy');
    if (!key || !proxy) return;

    fetch(proxy + '?ean=' + encodeURIComponent(key) + '&days=30', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (h) {
        if (!h) return;
        var current = Number(h.current);
        var low = Number(h.low30);
        var changes = Number(h.changes);
        if (!(current > 0) || !(low > 0)) return;
        if (!(changes >= 1)) return;
        // Cent-Toleranz: beide Werte kommen aus derselben Quelle, aber eine
        // Rundungsdifferenz darf das Signal nicht kippen.
        if (current > low + 0.005) return;
        node.hidden = false;
      })
      .catch(function () {
        /* Zugabe — bei jedem Fehler bleibt der Streifen unsichtbar. */
      });
  }

  function idle() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(boot, { timeout: 2500 });
    } else {
      setTimeout(boot, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', idle);
  } else {
    idle();
  }
})();
